import _ from 'lodash';
import { EmbedsApiServiceConfig } from './interfaces';
import { ApiService } from 'ui-common';

export class EmbedsConfigApiService extends ApiService {
  /**
   * 
   * Extract App Id from provided Api URL.
   * For example, 
   * `https://bb7dfa36-086b-4068-88a4-8ab065df6ed7.applications.lucidworks.com` => `bb7dfa36-086b-4068-88a4-8ab065df6ed7`
   */
  static extractAppIdFromAppPath(url: string) {
    const pattern = /https?:\/\/([^.]+)\./;
    const matches = pattern.exec(url);

    return matches ? matches[1] : null;
  }

  constructor(config: EmbedsApiServiceConfig) {
    const appId = EmbedsConfigApiService.extractAppIdFromAppPath(config.apiUrl || '') || '';
    const topLevelDomain = _.includes(config.apiUrl, '.com') ? 'com' : 'dev';

    const apiMeta = config.apiMeta || {
      config: {
        methods: [
          {
            uri: `/${appId}/beacon/config`,
            name: 'getBeaconConfig',
            verb: 'GET',
          }
        ]
      },
    };

    super(_.merge({
      getServiceHost: () => `https://api.lucidworks.${topLevelDomain}/applications`,
      apiMeta,
      apiPath: '',
  
      requestProps: {
        credentials: 'same-origin',
  
        headers: {
          ...(config.embedToken ? { authorization: `Embed ${config.embedToken}` } : {}),
        },
      },
    }, config));
  }
}